export default __webpack_public_path__ + "static/media/memory_icon.9fceb0b4.jpg";